module.exports = __webpack_public_path__ + "static/yeetleap-8b9466234cfb472ed2d1625818d7fae9.png";